import Tree from './Tree';
export default Tree;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/tree/index.js
// module id = 821
// module chunks = 0